import { render, staticRenderFns } from "./DiamondContractor.vue?vue&type=template&id=67bb19fa&scoped=true&"
var script = {}
import style0 from "./DiamondContractor.vue?vue&type=style&index=0&id=67bb19fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bb19fa",
  null
  
)

export default component.exports